import { Component, HostListener, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router, RouterLink } from "@angular/router";
import { CivilianRegistration, CivilianRegistrationRepository,
	PendingUserCivilian} from "src/app/repositories/registration/civilian-registration-repository";
import { FormsModule } from "@angular/forms";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatOptionModule } from "@angular/material/core";
import { States } from "./states";

@Component({
	selector: "jhmc-sign-up",
	templateUrl: "./sign-up.component.html",
	styleUrls: ["./sign-up.component.scss"],
	imports: [MatFormFieldModule, MatInputModule, FormsModule, RouterLink,
		MatRadioModule, MatSelectModule, MatOptionModule]
})
export class SignUpComponent implements OnInit
{
	public firstName: string;
	public lastName: string;
	public email: string;
	public password: string;
	public confirmPassword: string;
	public emailSent: boolean = false;
	public warningMessage: string;
	public civilianRegistrationId: string;
	private emailRegex: RegExp = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
	private civilianRegistrationRepository: CivilianRegistrationRepository;
	private router: Router;
	private route: ActivatedRoute;
	public isAttorney: boolean = false;
	public selectedState: string;
	public stateOptions: { key: string; value: any; }[] = Object.keys(States).map((state) => ({
		key: state, value: (States as any)[state]
	}));
	public lawSchoolName: string;
	public barNumber: string;
	public resendErrorMessage: string;
	public resendSuccessMessage: string;
	public pageInitialized: boolean = false;

	public constructor(civilianRegistrationRepository: CivilianRegistrationRepository,
		route: ActivatedRoute, router: Router)
	{
		this.civilianRegistrationRepository = civilianRegistrationRepository;
		this.router = router;
		this.route = route;
	}

	public ngOnInit(): void
	{
		this.route.queryParams.subscribe((params: Params) =>
		{
			if (params.confirmationId)
			{
				this.civilianRegistrationId = params.confirmationId;
				this.pageInitialized = true;
			}
			if (params.pendingUserCivilianId)
			{
				this.civilianRegistrationId = params.pendingUserCivilianId;
				this.resendEmail();
			}
			else
			{
				this.pageInitialized = true;
			}
		});
	}

	@HostListener("document:keydown.enter")
	public onDocumentKeydownEnter(): void
	{
		if (this.emailSent)
		{
			this.resendEmail();
		}
		else
		{
			this.sendSignUpEmail();
		}
	}

	public sendSignUpEmail(): void
	{
		if (!this.firstName)
		{
			this.warningMessage = "Please enter a first name.";
		}
		else if (!this.lastName)
		{
			this.warningMessage = "Please enter a last name.";
		}
		else if (!this.emailRegex.exec(this.email))
		{
			this.warningMessage = "Please enter a valid email address.";
		}
		else if (!this.password)
		{
			this.warningMessage = "Please enter a password.";
		}
		else if (this.password !== this.confirmPassword)
		{
			this.warningMessage = "Passwords do not match, please try again.";
		}
		else
		{
			this.initiateCivilianRegistration(new CivilianRegistration(this.civilianRegistrationId,
				this.firstName, this.lastName, this.email, this.password, this.isAttorney, this.lawSchoolName, this.barNumber));
		}
	}

	public resendEmail(): void
	{
		this.civilianRegistrationRepository.resendConfirmationEmail(this.civilianRegistrationId)
			.subscribe({
				next: () => {
					this.emailSent = true;
					this.resendErrorMessage = "";
					if (this.email)
					{
						this.resendSuccessMessage = "Email was sent to " + this.email;
					}
					else // If there is no email set, we came from the pendingUserCivlian page
					{
						this.resendSuccessMessage = "We just resent you the email.";
					}
					this.pageInitialized = true;
				},
				error: (error: Error) => {
					this.resendSuccessMessage = "";
					this.resendErrorMessage = "Unable to send email due to the following error: "
						+ error.message + ". If the problem persists, please contact support.";
					this.pageInitialized = true;
				}
			});
	}

	private initiateCivilianRegistration(civilianRegistration: CivilianRegistration): void
	{
		this.civilianRegistrationRepository.createNewCivilianRegistration(civilianRegistration)
			.subscribe(
				(pendingUserCivilian: PendingUserCivilian) =>
				{
					this.emailSent = pendingUserCivilian.emailSent;
					if (pendingUserCivilian.civilianUserAlreadyExisted)
					{
						const queryParams: any = {
							loginMessage: "The email you entered already has an account. "
								+ "Please login with your previous username and password."
						};
						this.router.navigate(["/login"], { queryParams });
					}
					else if (pendingUserCivilian.newCivilianUserCreated)
					{
						const queryParams: any = {
							loginMessage: "You were successfully registered. You can now login with the username and password you just created!"
						};
						localStorage.removeItem("access_token");
						this.router.navigate(["/login"], { queryParams });
					}
					else
					{
						this.civilianRegistrationId = pendingUserCivilian.pendingUserCivilianId;
					}
				});
	}
}
